export default __webpack_public_path__ + "static/media/Simon Game.4a33c928.png";